module.exports = __webpack_public_path__ + "static/key-fantasyblacksmith-a23d8996207216bf5a0fb6e5c1f10d08.webp";